/**
 * Даты расписания безопасности — общие для My Schedule и Group View.
 *
 * Все даты здесь — календарные дни 'YYYY-MM-DD', а не моменты времени, поэтому
 * разбираются без таймзоны: new Date('2026-09-08') в Каролине дал бы 7-е число.
 */

export const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function pad(n) {
    return String(n).padStart(2, '0');
}

/** 'YYYY-MM-DD' → локальная полночь этого дня. */
export function parseDay(workDate) {
    const [y, m, d] = workDate.split('-').map(Number);
    return new Date(y, m - 1, d);
}

/** Date → 'YYYY-MM-DD' по местному календарю. */
export function dayKey(date) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function todayKey() {
    return dayKey(new Date());
}

/** Воскресенье недели, в которую попадает дата, — та же формула, что на бэкенде. */
export function weekEndingOf(workDate) {
    const d = parseDay(workDate);
    const dow = d.getDay() === 0 ? 7 : d.getDay();
    d.setDate(d.getDate() + (7 - dow));
    return dayKey(d);
}

/** Семь дней недели, понедельник … воскресенье. */
export function weekDays(weekEnding) {
    const end = parseDay(weekEnding);
    const days = [];
    for (let i = 6; i >= 0; i--) {
        const d = new Date(end);
        d.setDate(d.getDate() - i);
        days.push(dayKey(d));
    }
    return days;
}

export function weekLabel(weekEnding, currentWeekEnding) {
    const end = parseDay(weekEnding);
    const start = new Date(end);
    start.setDate(start.getDate() - 6);
    const fmt = (x) => `${pad(x.getMonth() + 1)}/${pad(x.getDate())}`;
    if (weekEnding === currentWeekEnding) return `${fmt(start)} — ${fmt(end)} (current)`;
    if (weekEnding < currentWeekEnding) return `${fmt(start)} — ${fmt(end)} (last week)`;
    return `${fmt(start)} — ${fmt(end)}`;
}

/**
 * Порядок недель в выпадашке: сначала текущая, потом вперёд, прошедшие — в конец.
 * Человек открывает расписание ради сегодня и ближайших дней; прошлая нужна
 * изредка, и в самом верху она читается как ошибка.
 */
export function orderWeeks(weekEndings, currentWeekEnding) {
    const all = Array.from(new Set(weekEndings)).sort();
    const upcoming = all.filter((w) => w >= currentWeekEnding);
    const past = all.filter((w) => w < currentWeekEnding).reverse();
    return upcoming.concat(past);
}

/** Неделя из адресной строки — только если это действительно воскресенье. */
export function weekFromQuery(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    return weekEndingOf(value) === value ? value : null;
}
